import React, { useState, useEffect, useRef } from 'react';
import './dashboardsection.css';
import candidateDashboardImage from '../../../assets/images/Candidate_Dashboard.jpeg';
import { useNavigate } from 'react-router-dom';
import RegisterFlow from '../registerflow/registerflow';
const Dashboardsection = () => {
  const [activeSection, setActiveSection] = useState('default');
  const navigate = useNavigate();

  const sections = ['default', 'profile', 'users', 'pool', 'pricing', 'value', 'search'];
  const dashboardLinksRef = useRef(null);

  let currentIndex = sections.indexOf(activeSection);

  const content = {
    default: {
      heading: 'Everything You need to find the right candidate',
      paragraph: 'Unleash the power of personalized predictors and make informed hiring decisions with our candidate black box.',
    },
    profile: {
      heading: 'Detailed Candidate Profile',
      paragraph: 'Say goodbye to traditional resumes. Access a comprehensive candidate profile showcasing expertise, reporting structures, key achievements, and CTC breakdowns.',
    },
    pool: {
      heading: 'Verified Candidate Pool',
      paragraph: 'Leaderly has an authentic candidate pool. Our dedicated backend team communicates with the candidates to verify the information firsthand without any third-party interference. ',
    },
    users: {
      heading: 'Multiple Users',
      paragraph: 'Leaderly enables your team to access our powerful system from a single subscription. Assign roles to your team members and allow them to track the progress of your recruitment.',
    },
    pricing: {
      heading: 'Simple Pricing',
      paragraph: 'Leaderly’s inclusive pricing system empowers businesses to choose the subscription depending on their requirement. Our smart pricing chart is tailor-made for businesses of all sizes.',
    },
    value: {
      heading: 'Value-adds',
      paragraph: 'MetVid involves video interviews of candidates and MetRef includes discreet reference checks from past colleagues and managers for credibility. Our MetAssess suite includes psychometric tests, leadership assessments, and competency tests to ensure the right hire.',
    },
    search: {
      heading: 'Personalized Search',
      paragraph: 'Our Advanced Search Customization allows you to narrow your search and get accurate results with a desired match of up to 90%',
    },
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSection((prevSection) => {
        const currentIndex = sections.indexOf(prevSection);
        return sections[(currentIndex + 1) % sections.length];
      });
    }, 7000);

    return () => clearInterval(interval);
  }, []);

  const handleSectionClick = (section) => {
    setActiveSection(section);
  };

  // const handleKnowMoreClick = () => {
  //   if (!sessionStorage.getItem("initialScrollPosition")) {
  //     sessionStorage.setItem("initialScrollPosition", window.scrollY); 
  //   }
  //   sessionStorage.setItem("scrollPosition", window.scrollY);
  //   window.location.href = "/login"; 
  // };

  const [registerPopupVisible, setRegisterPopupVisible] = useState(false);

  const openRegisterPopup = () => {
    setRegisterPopupVisible(true);
  };

  const closeRegisterPopup = () => {
    setRegisterPopupVisible(false);
  };
  return (
    <div className='fluid-container'>
      <div className="dashboard-section-wrapper">
        <div className="dashboard-container">
          <div className="dashboard-background-lines"></div>
          <div className="dashboard-content">
            <div className="dashboard-text">
              <p className="dashboardsection-heading">{content[activeSection].heading}</p>
              <p className="dashboardsection-content">{content[activeSection].paragraph}</p>
            </div>
            <div className="dashboard-button-container">
              <button className="oval-button" onClick={openRegisterPopup}>
                Try Leaderly
              </button>
            </div>
            <RegisterFlow visible={registerPopupVisible} onClose={closeRegisterPopup} />
          </div>

          <div className="dashboard-links" ref={dashboardLinksRef}>
            {sections.slice(1).map((section) => (
              <a
                href="#"
                key={section}
                onClick={(e) => {
                  e.preventDefault();
                  handleSectionClick(section);
                }}
                className={activeSection === section ? "active" : ""}
              >
                {content[section].heading}
              </a>
            ))}
          </div>

          <div className="dashboard-image">
            <img src={candidateDashboardImage} alt="Dashboard" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboardsection;